import type { FreshnessStatus } from '../../shared/freshness/index.ts';
import { FRESHNESS_LABELS } from './freshness.ts';

export function FreshnessBadge({ status }: { status: FreshnessStatus }) {
  return (
    <span className={`badge badge--${status}`}>
      <span className="badge__dot" aria-hidden="true" />
      {FRESHNESS_LABELS[status]}
    </span>
  );
}

export function DemoBadge() {
  return (
    <span className="badge badge--demo" title="Données fictives de démonstration">
      Démo
    </span>
  );
}
